import {notificationStore} from '../../../store/stores/notification-store';
import {TNotificationProps} from '../../interface';

let dismissTimer: ReturnType<typeof setTimeout> | undefined;

export const activateNotification = (props: TNotificationProps) => {
  if (notificationStore.appIsOffline && props.kind === 'error') {
    return;
  }

  if (dismissTimer) clearTimeout(dismissTimer);
  notificationStore.setNotificationData(props);
  notificationStore.handleShowNotification(true);

  const duration = props.timeout ?? 4000;
  if (duration > 0) {
    dismissTimer = setTimeout(() => {
      notificationStore.handleShowNotification(false);
      dismissTimer = undefined;
    }, duration);
  }
};
